export default "__VITE_ASSET__3438c316__"